var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_InvoicingInformation"),
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticStyle: { height: "400px", "min-height": "400px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData,
          "wrap-text": true
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.selectedNode, type: "primary" },
              on: { click: _vm.setAsDefault }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("CargoMsg.Cargo_SetAsDefault") +
                    _vm.$t("CargoMsg.Cargo_InvoicingInformation")
                )
              )
            ]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.toAdd } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
          ),
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.selectedNode, type: "danger" },
              on: { click: _vm.toDelete }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.toSave } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }